<template>
    <h1>Without layout</h1>
</template>

<script setup>
definePageMeta({
    layout: 'default',
})
</script>